import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRole = route.data["expectedRole"] as Array<string>;;

    const userRoles = this.authService.getUserRoles();
    const hasRole = userRoles.some(role => expectedRole.includes(role));
console.log("HHHHH",userRoles,hasRole,expectedRole)
    // if (!userRoles.includes(expectedRole)) {
    //   // User doesn't have the required role, redirect to a forbidden page or home
    //   this.router.navigate(['/']);
    //   return false;
    // }
    if (!hasRole) {
      // Redirect or show an error message
      this.router.navigate(['/unauthorized']);
      return false;
    }

    // User has the required role, allow access to the route
    return true;
  }
}

